/**
 * AIN GOLD DIAMONDS — CUSTOM JAVASCRIPT  v1.0.0
 * Theme base: Primavera (Ultramarina)
 *
 * STRUCTURE:
 *   1. Namespace & Config
 *   2. Utility Helpers
 *   3. Feature Modules
 *   4. Init
 *
 * RULES:
 *   • All globals live under window.AGD — never pollute window directly
 *   • Never override or monkey-patch theme methods
 *   • Subscribe to theme-dispatched CustomEvents instead
 *   • Each feature must be its own object with an init() method
 *   • Guard every DOM query — elements may not exist on all pages
 */

(function () {
  'use strict';

  /* ============================================================
     1. NAMESPACE & CONFIG
     ============================================================ */

  window.AGD = window.AGD || {};

  AGD.config = {
    debug: false,
    breakpoints: {
      mobile: 768,
      tablet: 1024,
    },
  };


  /* ============================================================
     2. UTILITY HELPERS
     ============================================================ */

  AGD.utils = {

    log: function (msg, data) {
      if (!AGD.config.debug) return;
      data !== undefined
        ? console.log('[AGD]', msg, data)
        : console.log('[AGD]', msg);
    },

    /** Run fn immediately if DOM is ready, otherwise wait. */
    onReady: function (fn) {
      if (document.readyState !== 'loading') {
        fn();
      } else {
        document.addEventListener('DOMContentLoaded', fn);
      }
    },

    /** Safely query a single element; returns null without throwing. */
    qs: function (selector, context) {
      return (context || document).querySelector(selector);
    },

    /** Safely query all elements; returns empty NodeList without throwing. */
    qsa: function (selector, context) {
      return (context || document).querySelectorAll(selector);
    },

    /** Dispatch a namespaced custom event. */
    emit: function (name, detail) {
      document.dispatchEvent(new CustomEvent('agd:' + name, { detail: detail || {} }));
    },

    /** Subscribe to an AGD or theme custom event. */
    on: function (name, fn) {
      document.addEventListener(name, fn);
    },

  };


  /* ============================================================
     3. FEATURE MODULES
     Add each new feature as an object below with an init() method.
     Call it in section 4 → Init.

     Template:
       AGD.featureName = {
         init: function () {
           var el = AGD.utils.qs('.agd-feature');
           if (!el) return;   // guard: not on this page
           // ...
         },
       };
     ============================================================ */


  /**
   * Publishes Shopify custom analytics events for elements marked with
   * [data-shopify-analytics-event]. A Custom Pixel added in Shopify Admin
   * (Settings → Customer events → Add custom pixel) can then subscribe to
   * these event names and forward them to Meta / Google / any ads platform.
   * Uses Shopify's own analytics pipeline, so consent-gating (customer
   * privacy / GDPR / CCPA) is handled by Shopify automatically — no manual
   * pixel base code is loaded here.
   */
  AGD.analyticsEvents = {
    init: function () {
      document.addEventListener('click', function (event) {
        var el = event.target.closest('[data-shopify-analytics-event]');
        if (!el) return;
        if (!window.Shopify || !window.Shopify.analytics || typeof window.Shopify.analytics.publish !== 'function') {
          AGD.utils.log('Shopify.analytics.publish unavailable, skipping event', el.dataset.shopifyAnalyticsEvent);
          return;
        }

        var payload = {};
        (el.dataset.shopifyAnalyticsPayload || '').split('|').forEach(function (pair) {
          var parts = pair.split(':');
          if (parts[0]) payload[parts[0]] = parts.slice(1).join(':');
        });

        window.Shopify.analytics.publish(el.dataset.shopifyAnalyticsEvent, payload);
        AGD.utils.log('Published Shopify analytics event', { name: el.dataset.shopifyAnalyticsEvent, payload: payload });
      });
    },
  };


  /* ============================================================
     4. INIT
     ============================================================ */

  AGD.utils.onReady(function () {
    AGD.utils.log('AGD custom scripts initialized');

    // Call feature inits here:
    AGD.analyticsEvents.init();
  });

})();
